// import axios from "axios";
import { GETBUSINESSPROFILE, GETEMPLOYEELIST } from "../../utils/api";
import axios from "../../utils/axios";

export const cityNameCll=async(callback)=>{ 
    const ipResponse = await axios.get('https://api.ipify.org?format=json');
    const userIp = ipResponse.data.ip;
    //console.log('User IP:', userIp);
   
    const locationResponse = await axios.get(`http://ip-api.com/json/${userIp}`);
    //console.log('Location Data:', locationResponse.data);
    callback(locationResponse.data)
}
    
export const getEmployeeList = async (param) => {
  const res = await axios.post(GETEMPLOYEELIST, param, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const getBusinessProfile = async (param) => {
  const res = await axios.post(GETBUSINESSPROFILE, param, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res;
};
